import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ProductCarouselSkeleton } from '@yme/common/components/skeletons';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/index';
import { ProductCarousel } from '@yme/organisms/product-carousel';
import { getProducts } from '@yme/organisms/product-carousel/helpers';
import { getDaysToShowNew } from '@yme/selectors/index';
import { getProductCarouselParams, getProductDetails } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { ANALYTIC_RELATED_PRODUCT_KEY, DATA_TEST_ID } from './constants';
import { getRelatedProducts } from './services';
export function CustomersAlsoBought({ relatedProductsEndpoint, isRemoveBottomIndent, isInEditor, }) {
    const productCarouselCommonParams = useSelector(getProductCarouselParams);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const { isInfiniteDesktopView } = useWindowSize();
    const { data: productDetailsData } = useSelector(getProductDetails);
    const { t } = useTranslation();
    const daysToShowNew = useSelector(getDaysToShowNew);
    useEffect(() => {
        getRelatedProducts(relatedProductsEndpoint)
            .then((data) => {
            setRelatedProducts(data);
        })
            .finally(() => {
            setIsLoaded(true);
        });
    }, [relatedProductsEndpoint]);
    const handleOnClickCarouselItem = useCallback((product) => () => {
        setDigitalData(DigitalDataMutation.RELATED_ITEMS_WIDGET_CLICK, {
            product,
        });
        if (productDetailsData) {
            sessionStorage.setItem(ANALYTIC_RELATED_PRODUCT_KEY, JSON.stringify({
                previousAnalyticProduct: productDetailsData,
                relatedProductId: product.id,
            }));
        }
    }, [productDetailsData]);
    if (relatedProductsEndpoint && !isInEditor && !isLoaded) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(ProductCarouselSkeleton, { productHeight: isInfiniteDesktopView ? 390 : 306 })));
    }
    if (!relatedProductsEndpoint || !relatedProducts?.length) {
        return null;
    }
    const products = getProducts(relatedProducts) || [];
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(ProductCarousel, { dataTestId: DATA_TEST_ID, title: t('customersAlsoBought_title_label'), commonParams: productCarouselCommonParams, products: products, daysToShowNew: daysToShowNew, handleOnClickCarouselItem: handleOnClickCarouselItem })));
}
CustomersAlsoBought.displayName = 'CustomersAlsoBought_AEMComponent';
